import { Component, OnInit } from '@angular/core';
import { NavController, NavParams } from "ionic-angular";
import { AuthService } from "../../../services/auth.service";
import { AcceptInvitationData } from "../../../app/app.interfaces";
import { IonicHelper } from "../../../helpers/ionic.helper";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormValidators } from "../../../form/form.validators";
import { FormHelper } from "../../../helpers/form.helper";


@Component({
  selector: 'login',
  templateUrl: 'accept-invitation.html'
})
export class AcceptInvitation implements OnInit {

  token: string = null;
  invite: AcceptInvitationData = null;
  form: FormGroup;
  
  constructor(private nav: NavController, 
              private navParams: NavParams,
              private authService: AuthService,
              private ionic: IonicHelper,
              private formBuilder: FormBuilder) {
        
    
    
    
    
  }
  
  ngOnInit(): void {   
    
    this.ionic.toggleLoader();
    
    this.token = this.navParams.get('token');
    
    this.authService.isLoggedIn().then((loggedIn)=> {     
      if(loggedIn) {
        this.nav.setRoot('dashboard');        
      }
    });   
    
    this.authService.validateUserInviteToken(this.token).then((response)=>{
      this.invite = response.invite;
      this.ionic.toggleLoader(false);
      this.setupForm();
    }, (error)=> {
      this.ionic.toggleLoader(false);
      this.ionic.alert('ACCEPT_INVITE.TOKEN_ERROR').subscribe(() =>{
        this.nav.setRoot('login');
      });  
      
    });
    
  }
  
  setupForm(){
    
    let passwordGroup= this.formBuilder.group({
        password: ['', Validators.compose([Validators.minLength(6),Validators.maxLength(60), Validators.required])],
        confirmPassword: ['', [Validators.required ]] 
    }, {
      validator: FormValidators.matchFields
    });
    
    this.form = this.formBuilder.group({
      passwords: passwordGroup,
      email: [this.invite.email, Validators.compose([Validators.maxLength(60), Validators.email, Validators.required])],
      firstName: [this.invite.firstName, Validators.compose([Validators.minLength(3), Validators.required])],
      lastName: [this.invite.lastName, Validators.compose([Validators.minLength(3), Validators.required])],      
    })
    
    
  }
  
  
  submitForm(){
            
    if(this.form.valid){
      this.ionic.toggleLoader();
      
      let postData: AcceptInvitationData = {
        token: this.token,
        password: this.form.value.passwords.password,
        email: this.form.value.email,
        firstName: this.form.value.firstName,
        lastName: this.form.value.lastName,
      };
      
      this.authService.acceptInvitation(postData).then((response: any) => {
        
        this.ionic.toggleLoader(false);
        
        this.ionic.alert('ACCEPT_INVITE.DONE', 'GLOBAL.SUCCESS').subscribe(() => {
          this.ionic.toggleLoader(true);
          this.authService.login({email: postData.email, password: postData.password, rememberLogin: true}).then(() => {
          this.ionic.toggleLoader(false);
            this.nav.setRoot('dashboard');
          });
          
      });
        
      }, (error) => {
        this.ionic.toggleLoader(false);
        //Todo maybe specific error msg
        console.error(error);
        this.ionic.alert('GLOBAL.GENERAL_ERROR');
      });
    }
    else {
      //Todo maybe specific error msg
      // this.ionic.alert('LOGIN.RENEW_PASSWORD_FORM_INVALID');
      
    	this.ionic.invalidFieldsAlert(
    		'ACCEPT_INVITE.ERROR',
				'ACCEPT_INVITE.TRY_AGAIN',
				'ACCEPT_INVITE.ERRORS',
				FormHelper.getInvalidFormControls(this.form.controls)    		
			);
    	
    	
    }
    
    
  }
  
  
  
  
}


// WEBPACK FOOTER //
// ./src/components/login/accept-invitation/accept-invitation.ts